import Rails from "@rails/ujs"

Rails.start()

import "../src/images/apple_icon.png"
import "../src/images/favicon.ico"
import "../src/images/logo.png"
import "../src/stylesheets/application.scss"

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".notification").forEach(notification => {
    setTimeout(() => notification.remove(), 3000)
  })

  const navbarBurger = document.querySelector(".navbar-burger")
  const navbarMenu = document.querySelector(".navbar-menu")
  if (navbarBurger && navbarMenu) {
    navbarBurger.addEventListener("click", () => {
      navbarBurger.classList.toggle("is-active")
      navbarMenu.classList.toggle("is-active")
    })
  }

  const fileInput = document.querySelector('input[type="file"]')
  fileInput && fileInput.addEventListener("change", () => {
    const fileName = fileInput.files[0].name
    const fileNameSelector = document.querySelector(".file-name")
    fileNameSelector.textContent = fileName
  })
})
